var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWheelchair = function SvgIconWheelchair(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 2,
    r: 2,
    fill: "#5FC6B9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 5.5c-1 1-1 3 0 4",
    stroke: "#5FC6B9",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10h4l1 3",
    stroke: "#5FC6B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.535A4.006 4.006 0 0 0 2 11a4 4 0 0 0 7.465 2",
    stroke: "#5FC6B9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
export default SvgIconWheelchair;